import { Trans } from '@lingui/macro'
import HYDRA_DELEGATION_ABI from 'abis/governance/HydraDelegation.json'
import { useHydraDelegationContract } from 'hooks/useGovernanceContracts'

import ContractWidget from '../components/ContractWidget'
import { SectionTitle } from '../styleds'

export default function HydraDelegationTab() {
  const contract = useHydraDelegationContract()

  return (
    <>
      <SectionTitle>
        <Trans>HydraDelegation Contract (0x...0107)</Trans>
      </SectionTitle>

      <ContractWidget
        title="HydraDelegation"
        description="Delegation contract for delegators. Handles delegate/undelegate, vesting positions, commission management, and reward claims."
        contract={contract}
        abi={HYDRA_DELEGATION_ABI as any}
        defaultFunction="totalDelegation"
      />
    </>
  )
}
